<template>
  <div>
    <nnav></nnav>
    <!-- <div @click="export()">测试专用导出</div> -->
    <div class="bgimg">
      <div class="userlist">
        <div class="list_head">
          <!-- 搜索 -->
          <div class="topTitle" style="margin-left: 40px;padding: 8px 0  ;">
            <img
              style="margin-right: 8px;"
              src="../../../assets/images/dh111.png"
              alt=""
            />
            <span style="font-size: 14px;color: #2C2F37;">云服务</span
            ><span style="color: #868E99;font-size: 14px;"
              >&nbsp;>&nbsp;外部数据导入分析</span
            >
          </div>
          <!-- 账户列表 -->
          <div
            class="contnet"
            :style="{ minHeight: MHeight }"
            v-if="!type ? true : false"
          >
            <div class="search">
              <el-button icon="el-icon-plus" type="btn_color" @click="added"
                >批量导入</el-button
              >
              <label class="yunName" :style="{ border: border1 }">
                <input
                  type="text"
                  @focus="focus_account"
                  @blur="blur_account"
                  v-model="account"
                  placeholder="账号"
                />
              </label>
              <label class="yunName" :style="{ border: border2 }">
                <input
                  type="text"
                  @focus="focus_name"
                  @blur="blur_name"
                  v-model="name"
                  placeholder="投资者姓名"
                />
              </label>

              <label class="yunName" :style="{ border: border3 }">
                <input
                  type="text"
                  @focus="focus_companyName"
                  @blur="blur_companyName"
                  v-model="companyName"
                  placeholder="经纪公司名称"
                />
              </label>

              <div>
                <input class="btn" type="button" @click="search" value="搜索" />
                <input
                  class="btn"
                  style="background-color: #5B85FF;color: #fff;"
                  type="reset"
                  @click="reset"
                  value="重置"
                />
              </div>
            </div>
            <p
              :style="{ marginTop: '25px', fontSize: '16px', color: '#181E2D' }"
            >
              由于系统负荷原因，暂时支持导入5个账户数据进行分析。如有需要，
              请<a
                class="decoration1"
                href="/index/help/faq?type=4"
                :style="{ color: '#5B85FF' }"
                >联系我们</a
              >进行反馈。
            </p>
            <!-- 表格 -->
            <div class="table">
              <el-table
                :data="tableData"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  prop="y_set"
                  label="编辑"
                  width="62"
                  hieght="38"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      @click="ctp_edit(scope.row)"
                      :style="{ color: '#5B85FF', cursor: 'pointer',fontSize: '12px' }"
                      class="iconfont icon-bianji decoration"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="y_import"
                  label="导入"
                  width="62"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      @click="
                        ctp_push(
                          scope.row.id,
                          scope.row.clientId,
                          scope.row.clientName,
                          scope.row.daysCount
                        )
                      "
                      :style="{
                        color: '#5B85FF',
                        cursor: 'pointer',
                        fontSize: '16px'
                      }"
                      class="iconfont icon-xiazai decoration"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="y_assessment"
                  label="查看评估报告"
                  width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      @click="seeAssessment(scope.row.id)"
                      :style="{
                        color: '#5B85FF',
                        cursor: 'pointer',
                        fontSize: '16px'
                      }"
                      class="el-icon-search decoration"
                    ></i>
                  </template>
                </el-table-column>
                <el-table-column
                  label="交易日"
                  prop="clientId"
                  width="63"
                  colspan="2"
                  align="center"
                >
                  <template slot-scope="scope">
                    <!-- <div @click="scope.row.deleted=!scope.row.deleted" :style="{ color: '#255da8', cursor: 'pointer',display:'flex' }">
                      <span style="width: 50%;">{{scope.row.daysCount}}</span>&nbsp;&nbsp;&nbsp;<i
                      style="line-height: 19px;"
                      :class="scope.row.deleted?'el-icon-arrow-up':'el-icon-arrow-down'"
                    ></i>
                    </div> -->
                    <span style="width: 50%;">{{ scope.row.daysCount }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="" width="30" type="expand">
                  <template slot-scope="scope">
                    <span style="font-size: 14px;"
                      >&emsp;{{ scope.row.tradingDays }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column prop="clientId" label="账号">
                </el-table-column>
                <el-table-column prop="clientName" label="投资者姓名">
                </el-table-column>
                <el-table-column prop="brokerName" label="经纪公司名称">
                </el-table-column>
                <el-table-column
                  prop="y_delete"
                  label="删除"
                  width="62"
                  align="center"
                >
                  <template slot-scope="scope">
                    <i
                      @click="deleteItem(scope.row.id, scope.row.clientName)"
                      :style="{ color: '#5B85FF', cursor: 'pointer' }"
                      class="iconfont icon-shanchu decoration   "
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 分页 -->
            <div class="page_box">
              <div class="msg_count">共&nbsp;{{ length }}&nbsp;条</div>
              <div class="blank"></div>
              <div class="page">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="pageLength"
                  @current-change="currentPage"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="el-fade-in-linear">
      <!-- 导入罩层 -->
      <div class="popContainer" v-show="show" style="overflow-y: auto;">
        <div
          class="add"
          :style="{ width: '1020px', minHeight: '750px', marginTop: '100px' }"
        >
          <span
            class="close iconfont icon-close_round_fill_bold
        "
            @click="cancel"
          ></span>
          <div class="bg">
            <div
              class="import"
              style="padding: 25px 30px 0;height: 83px;box-sizing: border-box;"
            >
              批量导入结算单{{
                appoint ? ":" + clientId + "_" + clientName : ""
              }}
              <p>
                注意：您可以单次导入同一账号的多个结算单，请确保所选结算单都是属于同一账号。
              </p>
            </div>
            <div class="input" v-show="!appoint">
              <label for=""
                ><span>账号&nbsp;:&nbsp;</span
                ><el-input
                  placeholder=""
                  v-model="ctp_User"
                  :disabled="fileList.length > 0 ? false : true"
                >
                </el-input
              ></label>

              <label for=""
                ><span>姓名&nbsp;:&nbsp;</span
                ><el-input
                  placeholder=""
                  v-model="ctp_Name"
                  :disabled="fileList.length > 0 ? false : true"
                >
                </el-input
              ></label>

              <label for=""
                ><span>经纪公司&nbsp;:&nbsp;</span
                ><el-input
                  placeholder=""
                  v-model="ctp_CompanyName"
                  :disabled="fileList.length > 0 ? false : true"
                >
                </el-input
              ></label>
            </div>
            <div class="settlement" style="min-height: 540px;">
              <p>
                已选择{{ num }}个结算单。本次还能导入{{
                  appoint ? ctp_acount - daysCount - num : ctp_acount - num
                }}个结算单。
              </p>
              <div style="margin: 10px 0;">
                <el-upload
                  class="upload-demo"
                  :action="
                    this.$store.state.api + '/cloud/ctp_user/upload_file'
                  "
                  :on-preview="handlePreview"
                  :multiple="true"
                  :on-success="resres"
                  name="file"
                  :data="formdata"
                  :show-file-list="false"
                  :limit="240"
                  :before-upload="beforeUpload"
                  :on-exceed="handleExceed"
                  accept=".txt"
                >
                  <el-button size="small" icon="el-icon-plus" type="success"
                    >选择结算单</el-button
                  >
                  <span
                    >&nbsp;支持批量导入 txt 或 xls
                    格式逐日交易结算单（例如快期、保证金监控中心结算单）</span
                  >
                </el-upload>
              </div>
              <div class="table" style="max-height: 450px;overflow-y: auto;">
                <el-table
                  :data="fileList"
                  border
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column prop="" label="序号" width="62" type="index">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="文件名称">
                    <template slot-scope="scope">
                      <span>{{ scope.row.data.fileName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="" label="文件大小">
                    <template slot-scope="scope">
                      <span>{{ scope.row.data.fileSizeStr }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop=""
                    :label="state ? '状态' : '导入提示信息'"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <span
                        v-loading="
                          fileList ? !fileList[scope.$index].success : false
                        "
                        v-show="
                          fileList ? !fileList[scope.$index].success : false
                        "
                        >&emsp;&nbsp;&nbsp;</span
                      >
                      <span>{{ scope.row.message }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop=""
                    :label="delete_ ? '删除' : '结算日'"
                    width="80"
                  >
                    <template slot-scope="scope">
                      <i
                        v-show="delete_"
                        @click="
                          handleRemove(scope.$index, scope.row.data.fileName)
                        "
                        :style="{
                          color: '#1F55F4',
                          cursor: 'pointer',
                          fontSize: '14px'
                        }"
                        class="iconfont icon-shanchu"
                      ></i>
                      {{ scope.row.s_date ? scope.row.s_date : "" }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="progress" v-show="progress_show">
                <el-progress
                  :text-inside="true"
                  :stroke-width="18"
                  :percentage="
                    fileList.length
                      ? parseInt((ctp_success / fileList.length) * 100)
                      : 0
                  "
                  status="success"
                ></el-progress>
              </div>
            </div>
            <div class="submit_btn form_btn">
              <!-- <button v-if="btn_show" @click="cancel">取消</button> -->
              <button v-if="btn_show" @click="submitUpload">提交</button>

              <button
                style="width:100px;margin: 0 auto;background-color: #5b85ff;color: #fff;"
                type="primary"
                v-if="!btn_show"
                size="mini"
                @click="submitUploadOk"
              >
                导入完成
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in-linear">
      <!-- 编辑遮罩层 -->
      <div class="popContainer" v-show="edit_show">
        <div class="add" :style="{ width: '620px' }">
          <div class="close" @click="eidtCancel"></div>
          <div class="Top" :style="{ width: '600px' }">
            编辑
          </div>
          <span
            class="close iconfont icon-close_round_fill_bold
        "
            @click="eidtCancel"
          ></span>
          <div class="form_box" style="width: 550px;">
            <div class="form">
              <div class="col">
                <div class="left"><span>*</span> 账号</div>
                <div class="right">
                  <el-input
                    v-model="ctpUser"
                    placeholder=""
                    @blur="user_blur"
                  ></el-input>
                  <p class="error_msg" v-show="user_show">请填写该字段</p>
                </div>
              </div>

              <div class="col">
                <div class="left"><span>*</span> 投资者姓名</div>
                <div class="right">
                  <el-input
                    v-model="ctpName"
                    placeholder=""
                    @blur="ctpName_blur"
                  ></el-input>
                  <p class="error_msg" v-show="ctpName_show">请填写该字段</p>
                </div>
              </div>
              <div class="col">
                <div class="left"><span>*</span> 经纪公司名称</div>
                <div class="right">
                  <el-input
                    placeholder=""
                    v-model="ctpCompanyName"
                    @blur="ctpCompany_blur"
                  ></el-input>
                  <p class="error_msg" v-show="ctpCompany_show">请填写该字段</p>
                </div>
              </div>
            </div>
          </div>
          <div class="form_btn">
            <!-- <button @click="eidtCancel">取消</button> -->
            <button @click="editSubmit">提交</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import nnav from "../../../components/nav/index";
import "@/assets/icon/iconfont.css";
import "./style.css";
export default {
  name: "eval_jees",
  components: { nnav },
  data() {
    return {
      border1: "",
      border2: "",
      border3: "",
      loading: true,
      progress_show: false, //控制进度条显示隐藏
      ctp_length: "",
      btn_show: true, //控制按钮显示隐藏
      s_date: "", //导入成功结算日
      delete_: true, //导入 删除 结算日切换
      state: true, //导入 状态 导入信息切换
      pushID: null,
      clientId: "",
      clientName: "",
      appoint: false,
      daysCount: null,
      ctpCompany_show: false,
      ctpName_show: false,
      editId: "", //编辑当前数据的ID
      ctpUser: "",
      ctpName: "",
      ctpCompanyName: "",
      edit_show: false, //编辑遮罩层
      ctp_User: "", //账号
      ctp_Name: "", //姓名
      ctp_CompanyName: "", //公司名称
      formdata: { apiToken: this.$store.state.usermsg.apiToken }, //token
      type: "",
      ctp_acount: "", //结算单最大数量
      num: 0, //结算单当前数量
      user_show: false,
      pwd_show: false,
      addYun: true,
      user: "",
      pwd: "",
      name_c: "1",
      account_c: "3",
      down: "el-icon-arrow-down",
      down_up: false,
      page: 1, //当前分页
      length: "", //账户列表总数
      pageLength: null, //账户列表分页长度
      show: false,
      yunName: false,
      yunName_b: false,
      accountTypeShow: false,
      err_show: true,
      err_show1: true,
      err_show2: true,
      account: "",
      name: "",
      btn_color: "primary", //批量导入按钮颜色
      companyName: "",
      yun_name: "私有云名称",
      accountType: "账户类型",
      tableData: [],

      accountTypeList: ["投顾账户", "产品独立账户"],
      fileList: [],
      ctp_success: 0,
      MHeight: document.documentElement.clientHeight - 160 + "px"
    };
  },
  created() {
    // console.log(this.formdata);
    this.pageAxios();
    this.$axios
      .post("/cloud/ctp_user/upload_ajax", {
        apiToken: this.$store.state.usermsg.apiToken,
        ctpUserId: this.$store.state.usermsg.id
      })
      .then(res => {
        this.ctp_acount = res.data;
      })
      .catch(err => {
        // console.log(err);
      });
  },
  mounted() {
    // 注意一定要保证DOM渲染完成后在进行合并操作，否则会找不到元素
    this.$nextTick(function() {
      this.setColSpan();
    });
  },
  methods: {
    setColSpan: function() {
      //合并表头单元格
      // // console.log(document.getElementsByClassName("el-table__header"))
      // 获取表头的所有单元格
      var x = document.getElementsByClassName("el-table__header")[0].rows[0]
        .cells;
      // 将第4列表头单元格的colSpan设为2
      x[3].colSpan = 2;
      // 将第5列表头单元格的display设为none
      x[4].style.display = "none";
    },
    ctp_push(id, clientId, clientName, daysCount) {
      //指定导入
      this.show = true;
      this.appoint = true;
      this.clientId = clientId;
      this.clientName = clientName;
      this.daysCount = daysCount;
      this.pushID = id;
    },
    seeAssessment(id) {
      //查看评估按钮
      localStorage.setItem("userId", id);
      this.$axios
        .post("/cloud/ctp_user/check", {
          apiToken: this.$store.state.usermsg.apiToken,
          userId: id
        })
        .then(res => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            window.open(
              "_blank"
            ).location.href = `/user/ctp_user/view?userId=${id}`;
          } else {
            this.$alert(res.data.message, {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    eidtCancel() {
      //取消编辑
      this.edit_show = false;
      this.ctpUser = "";
      this.ctpName = "";
      this.ctpCompanyName = "";
      this.editId = "";
    },
    editSubmit() {
      //提交编辑
      this.$axios
        .post("/cloud/ctp_user/saveEdit", {
          apiToken: this.$store.state.usermsg.apiToken,
          clientId: this.ctpUser,
          clientName: this.ctpName,
          brokerName: this.ctpCompanyName,
          id: this.editId
        })
        .then(res => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.eidtCancel();
            this.pageAxios();
          }
        })
        .catch(err => {
          // console.log(err);
        });
    },
    ctp_edit(res) {
      //编辑
      this.edit_show = true;
      this.editId = res.id;
      this.ctpUser = res.clientId;
      this.ctpName = res.clientName;
      this.ctpCompanyName = res.brokerName;
    },
    beforeUpload(e) {
      //导入前
    },
    handleRemove(index, name) {
      // console.log(this.fileList);
      this.$confirm(
        `确认删除账户“${name}”么？删除账户将导致该账户已导入数据被清空，请谨慎操作！`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.num--;
          this.fileList.splice(index, 1);
        })
        .catch(() => {});
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${ctp_acount} 个文件，本次选择了 ${num} 个文件`
      );
    },
    // 文件上传
    resres(e) {
      //导入成功返回
      if (e.code == 200) {
        this.num++;
        e.message = "待导入";
        this.fileList.push(e);
        // console.log(this.fileList.length);
        if (this.fileList.length <= 1) {
          this.$axios
            .post("/cloud/ctp_user/get_user_ajax", {
              apiToken: this.$store.state.usermsg.apiToken,
              uploadPathStr: e.data.filePath
            })
            .then(res => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                let result = res.data.message.split("%");

                this.ctp_User = result[0];
                this.ctp_Name = result[1];
                this.ctp_CompanyName = result[2];
              }
            })
            .catch(err => {
              // console.log(err);
            });
        }
      }

      // if(e.code == 200){
      //   this.num++ //已选择结算单数量

      // this.$axios.post(
      //   this.$store.state.api + '/cloud/ctp_user/get_user_ajax',
      //   {apiToken: this.$store.state.usermsg.apiToken,uploadPathStr:e.data.filePath}
      // ).then(res=>{
      //   // console.log(res)
      //   if(res.data.code == -1){

      //     e.message = res.data.message
      //   }

      //   if(res.data.code==200){
      //     e.message = '待导入'
      //   let result = res.data.message.split('%')
      //   // console.log(result[0])
      //      this.ctp_User = result[0]
      //      this.ctp_Name = result[1]
      //      this.ctp_CompanyName = result[2]
      //   }

      // }).catch(err=>{
      //   // console.log(err)
      // })
      // }
    },
    submitUpload(e) {
      //提交按钮
      let sum = this.appoint
        ? this.ctp_acount - this.daysCount - this.num
        : this.ctp_acount - this.num;
      // console.log(this.fileList);
      //列表提交
      if (sum >= 0) {
        if (!this.appoint) {
          if (this.ctp_User && this.ctp_Name && this.ctp_CompanyName) {
            this.$axios
              .post("/cloud/ctp_user/saveNew", {
                apiToken: this.$store.state.usermsg.apiToken,
                clientId: this.ctp_User,
                clientName: this.ctp_Name,
                brokerName: this.ctp_CompanyName
              })
              .then(res => {
                let i = 0;
                if (this.fileList.length > 0) {
                  this.progress_show = true;
                }
                this.ctp_length = this.fileList.length;
                this.tokenInvalid(res);
                if (res.data.code == 200) {
                  this.state = false;
                  this.delete_ = false;
                  this.forAxios(res, i);
                } else {
                  this.$alert(res.data.message, {
                    confirmButtonText: "确定",
                    type: "error",
                    center: true
                  })
                    .then(() => {})
                    .catch(() => {});
                }
              })
              .catch(err => {
                this.fileList[0].message = "导入失败";
              });
          } else {
            this.$alert("请填写账号，姓名，经纪公司名称", {
              confirmButtonText: "确定",
              type: "error",
              center: true
            })
              .then(() => {})
              .catch(() => {});
          }
        }
        //选择提交
        if (this.appoint) {
          // console.log(this.fileList);
          if (this.fileList.length > 0) {
            this.progress_show = true;
          }
          let i = 0;
          this.state = false;
          this.delete_ = false;
          this.forAxios(this.pushID, i);
        }
      } else {
        this.$alert("导入结算单到达上限", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    forAxios(res, i) {
      //循环提交
      // console.log(this.fileList[i].success);
      this.fileList[i].success = false;
      this.fileList[i].message = "导入中";
      this.$axios
        .post("/cloud/ctp_user/doUpload", {
          apiToken: this.$store.state.usermsg.apiToken,
          uploadPathStr: this.fileList[i].data.filePath,
          uploadNameStr: this.fileList[i].data.fileName,
          ctpUserId: res.data ? res.data.data.id : res
        })
        .then(result => {
          // console.log(result);
          this.fileList[i].success = true;
          this.tokenInvalid(result);
          if (result.data.code == 200) {
            this.btn_show = false;
            this.fileList[i].message = "导入成功";
            this.fileList[i].s_date = result.data.message.split("&")[1];
          } else {
            this.fileList[i].message = result.data.message.split("&")[0];
            this.btn_show = false;
          }

          this.ctp_success++; //进度条完成的数量
          i++;
          if (this.fileList.length > i) {
            this.forAxios(res, i);
          }
        })
        .catch(err => {
          this.fileList[i].scuuess = true;
          // console.log(err);
          this.fileList[i].message = "导入失败";
          this.ctp_success++; //进度条完成的数量
          i++;
          if (this.fileList.length > i) {
            this.forAxios(res, i);
          }
        });
    },
    submitUploadOk() {
      //导入完成按钮
      // this.show = false
      window.location.reload();
      // this.btn_show = true
    },

    pageAxios() {
      this.$axios({
        method: "post",
        url: "/cloud/ctp_user/list",
        params: {
          page_no: 1,
          size: 1000,
          clientId: this.account,
          clientName: this.name,
          brokerName: this.companyName,
          apiToken: this.$store.state.usermsg.apiToken
        }
      }).then(result => {
        this.tokenInvalid(result);
        if (result.data.code == 200) {
          this.length = result.data.data.length;
          this.pageLength = Math.ceil(result.data.data.length);
        }
      });

      this.$axios({
        method: "post",
        url: "/cloud/ctp_user/list",
        params: {
          page_no: this.page,
          size: 10,
          clientId: this.account,
          clientName: this.name,
          brokerName: this.companyName,
          apiToken: this.$store.state.usermsg.apiToken
        }
      }).then(res => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200) {
          this.tableData = res.data.data;
        }
        // // console.log(this.tableData)
      });
    },
    search() {
      //模糊搜索
      this.pageAxios();

      // var that = this;
      // var arr = [];
      // this.$axios({
      //   method: 'post',
      //   url: '/cloud/ctp_user/list',
      //   params: {
      //     page_no: 1,
      //     size: 1000,
      //     apiToken: this.$store.state.usermsg.apiToken,
      //   },
      // }).then((res) => {
      //   // console.log(res);
      //   if (res.data.code == 200) {
      //     res.data.data.forEach((item) => {
      //       if (
      //         item.clientId.indexOf(that.account) != -1 &&
      //         item.clientName.indexOf(that.name) != -1 &&
      //         item.brokerName.indexOf(that.companyName) != -1
      //       ) {
      //         arr.push(item);
      //       }
      //     });
      //     that.tableData = arr;
      //     that.length = arr.length
      //   }
      //   // // console.log(this.tableData)
      // });
    },
    added() {
      //添加按钮
      if (this.tableData.length < 5) {
        this.show = true;
        this.appoint = false;
      } else {
        this.$alert("账户最多不得超过5个", {
          confirmButtonText: "确定",
          type: "error",
          center: true
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    yun(e) {
      //私有云名称按钮

      this.yunName = !this.yunName;
    },
    yun_b() {
      this.yunName_b = !this.yunName_b;
    },
    accountAdd() {
      //账户类型按钮
      this.accountTypeShow = !this.accountTypeShow;
    },

    focus_account() {
      //账户输入框聚焦
      this.border1 = "1px solid #7195FF";
    },
    focus_name() {
      //姓名输入框聚焦
      this.border2 = "1px solid #7195FF";
    },
    focus_companyName() {
      this.border3 = "1px solid #7195FF";
    },
    blur_account() {
      //账户输入框失焦
      this.border1 = "";
    },

    blur_name() {
      //姓名输入框失焦
      this.border2 = "";
    },
    blur_companyName() {
      this.border3 = "";
    },
    reset() {
      //重置按钮
      this.account = "";
      this.name = "";
      this.companyName = "";
      this.search();
    },
    accountTypeAdd(item) {
      //选择账户类型
      this.accountType = item;
      this.accountTypeShow = false;
    },
    cancel() {
      this.progress_show = false;
      this.show = false;
      this.fileList = [];
      this.num = 0;
      this.ctp_User = ""; //账号
      this.ctp_Name = ""; //姓名
      this.ctp_CompanyName = ""; //公司名称
    },
    inp_blurUser() {
      this.accountTypeShow = false;
    },
    inp_blur() {
      this.yunName = false;
    },
    inp_blur_b() {
      this.yunName_b = false;
    },
    submit() {},
    console_submit() {},
    user_blur() {
      if (this.ctpUser.length == 0) {
        this.user_show = true;
      } else {
        this.user_show = false;
      }
    },
    ctpCompany_blur() {
      if (this.ctpCompanyName.length == 0) {
        this.ctpCompany_show = true;
      } else {
        this.ctpCompany_show = false;
      }
    },
    ctpName_blur() {
      if (this.ctpName.length == 0) {
        this.ctpName_show = true;
      } else {
        this.ctpName_show = false;
      }
    },
    pwd_blur() {
      if (this.pwd.length == 0) {
        this.pwd_show = true;
      } else {
        this.pwd_show = false;
      }
    },
    console_add() {},
    currentPage(e) {
      //当前页
      this.page = e;
      this.pageAxios();
      // console.log(this.page);
    },
    deleteItem(id, clientName) {
      let that = this;

      this.$confirm(
        `确认删除账户“${clientName}”么？删除账户将导致该账户已导入数据被清空，请谨慎操作！？`,
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$axios({
            method: "post",
            url: "/cloud/ctp_user/del",
            params: {
              id: id,
              apiToken: this.$store.state.usermsg.apiToken
            }
          })
            .then(res => {
              // console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                that.pageAxios();
                that.length--;
                if (that.tableData.length > 1) {
                  that.pageLength--;
                }
              } else {
                this.$alert("操作失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  center: true
                })
                  .then(() => {})
                  .catch(() => {});
              }
              // // console.log(this.tableData)
            })
            .catch(err => {
              // console.log(err);
            });
        })
        .catch(() => {});
    },
    export(){
      window.open("_blank").location.href = `/crm/yunReport?id=130082&startTime=20190603&endTime=20190612&customerId=60039&view=&settings=`;
    }
  },
  watch: {
    fileList() {
      if (this.fileList.length >= 10) {
      }
    },

    name_c() {
      if (this.name_c == 1) {
        this.addYun = true;
      }
      if (this.name_c == 2) {
        this.addYun = false;
      }
    }
  }
};
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/view/user/ctp_user/index.vue